//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.AllVesselNameQuery_ResponseAdapter
import com.wintermar.inspection.graphql.selections.AllVesselNameQuerySelections
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public class AllVesselNameQuery() : Query<AllVesselNameQuery.Data> {
  override fun equals(other: Any?): Boolean = other != null && other::class == this::class

  override fun hashCode(): Int = this::class.hashCode()

  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    // This operation doesn't have any variable
  }

  override fun adapter(): Adapter<Data> = AllVesselNameQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = AllVesselNameQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(AllVesselNameQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val allVesselName: List<AllVesselName>,
  ) : Query.Data

  public data class AllVesselName(
    public val id: Any,
    public val name: String,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "5aa655fdb481ea1cd5011178f1bf26f1ce0e1cc6315c31d123212fb1432c0f49"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query allVesselName {
     *   allVesselName {
     *     id
     *     name
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query allVesselName { allVesselName { id name } }"

    public const val OPERATION_NAME: String = "allVesselName"
  }
}
